import { render, staticRenderFns } from "./MultiCartShelfManager.vue?vue&type=template&id=22331b70&scoped=true"
import script from "./MultiCartShelfManager.vue?vue&type=script&lang=js"
export * from "./MultiCartShelfManager.vue?vue&type=script&lang=js"
import style0 from "./MultiCartShelfManager.vue?vue&type=style&index=0&id=22331b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22331b70",
  null
  
)

export default component.exports